<section [formGroup]="form" class="chip-list">
  <mat-chip-listbox class="mat-chip-set" multiple selectable [formControlName]="this.key" [id]="this.key"
      [value]="this.value">
      @for(option of this.options; track option.value) {
          <mat-chip-option class="mat-chip-option" selectable #chip [value]="option.value"
              [selected]="isSelected(option.value)" (mouseenter)="onMouseEnter(chip)" (mouseleave)="onMouseLeave(chip)">
              <span class="flex flex-row">
                  @if(option.icon) {
                      @for(icon of this.getIcons(option.icon); track icon) {
                          <lib-app-icon [icon]="icon" size="16x16"></lib-app-icon>
                      }
                  }
                  <span class="pl-[6px]">{{option.viewValue}}</span>
              </span>
          </mat-chip-option>
      }
  </mat-chip-listbox>
</section>